import Button from "@rio-cloud/rio-uikit/Button";

interface Props {
  selectedCount: number;
  disabled?: boolean;
  onClick: () => void;
}

const DeleteSelectedButton = ({ selectedCount, disabled = false, onClick }: Props) =>
  selectedCount > 0 ? (
    <Button
      bsStyle={Button.DANGER}
      iconName="rioglyph-trash"
      className="rounded-small width-190"
      disabled={disabled}
      onClick={onClick}
    >
      Excluir Selecionados ({selectedCount})
    </Button>
  ) : null;

export default DeleteSelectedButton;
